const EVENT_NAME = 'npc:operations-announcement';
const SOCKET_EVENT = 'operations:announcement';
const seen = new Map();

function readLocalUser() {
  if (typeof window === 'undefined') return {};
  try { return JSON.parse(window.localStorage.getItem('user') || '{}') || {}; } catch (_) { return {}; }
}

function buildAgentPath(user = {}) {
  const values = [
    user.agent_id, user.agentId, user.agent_code, user.agentCode,
    user.line_code, user.lineCode, user.cached_line_code, user.cachedLineCode,
    user.root_lv1_id, user.rootLv1Id,
  ].filter((value) => value !== null && value !== undefined && String(value).trim()).map(String);
  const lineCode = String(user.line_code || user.lineCode || user.cached_line_code || user.cachedLineCode || '').trim();
  let cumulative = '';
  for (const piece of lineCode.split('-').filter(Boolean)) {
    cumulative = cumulative ? `${cumulative}-${piece}` : piece;
    values.push(piece, cumulative);
  }
  return [...new Set(values)];
}

export function buildOperationsSocketContext() {
  const user = readLocalUser();
  let language = 'en';
  try {
    language = String(window.localStorage.getItem('app_language') || 'en').trim().toLowerCase();
  } catch (_) {}
  return { agentPath: buildAgentPath(user), language };
}

function announcementKey(value = {}) {
  return String(value.id || value.announcementId || value.key || `${value.title || ''}:${value.message || ''}:${value.startsAt || ''}`);
}

export function dispatchOperationsAnnouncement(payload = {}, source = 'socket') {
  const announcement = payload && typeof payload === 'object' ? { ...payload } : {};
  const key = announcementKey(announcement);
  const version = String(announcement.version || announcement.updatedAt || announcement.receivedAt || '1');
  const signature = `${key}:${version}`;
  const last = seen.get(key);
  if (last === signature) return false;
  seen.set(key, signature);
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: { ...announcement, id: key, source, receivedAt: announcement.receivedAt || new Date().toISOString() },
    }));
    return true;
  } catch (_) {
    return false;
  }
}

export function subscribeOperationsAnnouncements(listener) {
  if (typeof window === 'undefined' || typeof listener !== 'function') return () => {};
  const handler = (event) => listener(event?.detail || {});
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}

export { EVENT_NAME as OPERATIONS_ANNOUNCEMENT_EVENT, SOCKET_EVENT as OPERATIONS_ANNOUNCEMENT_SOCKET_EVENT };
